import React from 'react';
import {Outlet} from 'react-router-dom';

const Productions: React.FC = () => {
  return <Outlet />;
};

export default Productions;
